import React from "react";
import {Button} from "../../components/inputs/ajonjolinput";

export default function NotFound() {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            alignContent: 'center',
            height: '100vh'
        }}>
            <div style={{
                marginTop: '-5rem',
                fontWeight: 600,
                fontSize: '5rem',
            }}>
                <div>404 Not Found</div>
                <div style={{
                    display: "flex",
                    justifyContent: 'center'
                }}>
                    <Button name={'Go Home'} onSubmit={() =>{
                        window.location.replace('/')
                    }}/>
                </div>
            </div>
        </div>
    )
}